import { Navigate, Outlet } from "react-router-dom";
import { userIsFullyLoggedIn } from "../../../helpers/user";

const ProtectedRoute = ({ isAllowed, redirectPath, children }) => {
  const isLogged = userIsFullyLoggedIn();

  if (!isLogged) {
    return <Navigate to="/login" replace />;
  } else {
    return children ? children : <Outlet />;
  }
};

export default ProtectedRoute;
